import { Box, Button, Center, Flex, Image, Input, Text, Link, Spacer } from "@chakra-ui/react";
import React, { useState, useRef, useEffect } from "react";
import logo from '../assets/login-gremio-lg.png';
import bg from '../assets/login-bg.jpg';
import * as ls from "../servicos/Login";
import { useNavigate } from "react-router-dom";
import InputMask from 'react-input-mask';
import '../Firebase'; 
import { fetchToken } from "../Firebase";
import { versao } from "../servicos/Versao";
import InstallPWAButton from "../servicos/InstallPWAButton";

const toSeconds = (timeStr) => {
    if (!timeStr || !timeStr.includes(':')) return 0;
    const [min, sec] = timeStr.split(':').map(Number);
    return min * 60 + sec;
};

const toTime = (seconds) => {
    const min = Math.floor(seconds / 60);
    const sec = seconds % 60;
    return `${String(min).padStart(2, '0')}:${String(sec).padStart(2, '0')}`;
};


const Login = (props) => {

    var navigate = useNavigate();

    const [cpf, setCpf] = useState('');
    const [codigo, setCodigo] = useState('');

    const [smsEnviado, setSmsEnviado] = useState(false);
    const [whatsEnviado, setWhatsEnviado] = useState(false);
    const [celular, setCelular] = useState('');

    const [tempoWhats, setTempoWhats] = useState('');
    const [segundosRestantes, setSegundosRestantes] = useState(toSeconds(tempoWhats));
    const intervaloRef = useRef(null);

    useEffect(() => {
        clearInterval(intervaloRef.current);
        setSegundosRestantes(toSeconds(tempoWhats));
    }, [tempoWhats]);

    useEffect(() => {
        if (segundosRestantes > 0) {
        intervaloRef.current = setInterval(() => {
            setSegundosRestantes(prevSegundos => prevSegundos - 1);
        }, 1000);
        
        return () => clearInterval(intervaloRef.current);
        }
        
        clearInterval(intervaloRef.current);
    }, [segundosRestantes]); 


    const login = async (passo) => {
        if(cpf !== ''){
            var aux = cpf.replace('.','').replace('.','').replace('-','');
            var aux_codigo = codigo;

            if(passo === 3){
                aux_codigo = 'BOT_WHATSAPP';
            }

            const response = await ls.login(aux, aux_codigo);
            if(response.erro === 0){
                if(passo === 1 && response.msg === 'SMS'){
                    setSmsEnviado(true);
                    setCelular(response.cel);
                    setTempoWhats(response.tempo_whats);
                }else if(passo === 2 && response.msg === 'OK'){
                    localStorage.setItem('ac', response.access_token);
                    localStorage.setItem('expires_in', response.expires_in);
                    localStorage.setItem('rt', response.refresh_token);
                    localStorage.setItem('token_type', response.token_type);
                    localStorage.setItem('matricula', response.matricula);
                    localStorage.setItem('tn', response.topico_notificacao);
                    props.setLogado(true);
                    fetchToken();
                    // if (Notification.permission !== "granted") {
                    //     Notification.requestPermission().then(function(permission) {
                    //         if (permission === "granted") {
                    //         console.log("Permissão de notificação concedida!");
                    //         } else {
                    //         console.log("Permissão de notificação negada.");
                    //         }
                    //     });
                    // }
                    console.log('fetchToken login');
                    navigate('/');
                }else if(passo === 3 && response.msg === 'WHATSAPP'){
                    setSmsEnviado(true);
                    setWhatsEnviado(true);
                    setTempoWhats(response.tempo_whats);
                }else if(passo === 3 && response.msg !== 'WHATSAPP'){
                    setTempoWhats(response.tempo_whats);
                    window.alert(response.msg);
                }else{
                    window.alert('tente novamente');
                }
            }else{
                window.alert(response.msg);
            }
        }
    };

    const whats = () => {
        if(segundosRestantes === 0){
            login(3);
        }
    };

    return(
        <Center>
        <Box w={{base: '100%', sm: '500px'}} backgroundImage={bg} backgroundSize='cover'>
            <Flex h='100vh' direction='column' px='6' justifyContent='center' alignItems='center'>
                <Image h='160px' src={logo} mb='4'/>
                { smsEnviado === false ? <>
                    <Input as={InputMask} mask='999.999.999-99' type='text' variant='filled' size='lg' value={cpf} onChange={(e) => setCpf(e.target.value)} _focus={{background: '#ffffff'}} mb='6' colorScheme='white' placeholder='CPF'/>
                    <Button bgColor='blue.400' color='white' h='50px' px='6' mb='6' onClick={() => login(1)}>CONTINUAR</Button>
                    <Text fontSize='sm' as='a' color='white'>Não sou conselheiro</Text> 
                    </> : <>
                        <Text fontSize='sm' color='white'>{whatsEnviado ? `Whatsapp enviado para o número ${celular}` : `SMS enviado para o número ${celular}`}</Text>
                        <Input type='text' variant='filled' size='lg' value={codigo} onChange={(e) => setCodigo(e.target.value)} _focus={{background: '#ffffff'}} mb='6' colorScheme='white' placeholder='Digite o código do SMS/Whatsapp'/>
                        <Button bgColor='blue.400' colorScheme='blue' color='white' h='50px' px='6' mb='6' onClick={() => login(2)}>CONTINUAR</Button>

                        <Link onClick={() => whats()} marginTop={'20px'} color='white'>Enviar por Whatsapp {segundosRestantes > 0 ? `(Aguarde ${toTime(segundosRestantes)})` : ''}</Link>
                    </>
                }
                <Text fontSize='sm' color='white' marginTop={'40px'}>Versão {versao}</Text>
                <InstallPWAButton/>
            </Flex>
        </Box>
        </Center>
    );
};

export default Login;